import {Injectable} from '@angular/core';
import {CeStorageService} from '../storage/ce-storage.service';

@Injectable()
export class CeContextService {
    public constructor(
        private storage: CeStorageService,
    ) {
    }

    public get(): any | null {
        return this.storage.get();
    }

    public set(ce: any): void {
        this.storage.set(ce);
    }
}



// WEBPACK FOOTER //
// ./src/shared/services/context/ce-context.service.ts